import {useContext, useEffect} from "react";
import {AppContext} from "../../AppContext.jsx";

export const useListenToSocket = ({eventName, onUpdate, room}) => {
    const {listenToEvent, unListenToEvent, joinRoom, leaveRoom} = useContext(AppContext);

    useEffect(() => {
        if (room && joinRoom) {
            joinRoom(room);
        }
        if (eventName && listenToEvent && unListenToEvent) {
            listenToEvent(eventName, onUpdate);
        }
        return () => {
            unListenToEvent(eventName);
            if (room && leaveRoom) {
                leaveRoom(room);
            }
        };
    }, [eventName, listenToEvent, onUpdate, unListenToEvent, room, joinRoom, leaveRoom]);
};
